var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-profile-section-busy-overlay",class:{ 'c-profile-section-busy-overlay--bottom-offset': _vm.bottomOffset !== null },style:(_setup.overlayStyle)},[_c(_setup.BCLoadingAnimation,{staticClass:"c-spinner",attrs:{"loading-animation":_vm.loadingAnimation,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }